import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import CompanyLayout from "layouts/company";
import SubscriptionPlans from "views/subscription/SubscriptionPlans";
import ProtectedRoute from "components/routing/ProtectedRoute";
import AuthRoute from "components/routing/AuthRoute";
import Downloads from "components/downloads/Downloads";
import EmployeeProfile from "views/employee/profile/Profile";

const App = () => {
  return (
    <Routes>
      <Route
        path="auth/*"
        element={
          <AuthRoute>
            <AuthLayout />
          </AuthRoute>
        }
      />
      <Route
        path="admin/*"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      />
      <Route
        path="company/*"
        element={
          <ProtectedRoute>
            <CompanyLayout />
          </ProtectedRoute>
        }
      />
      <Route path="subscription/plans" element={<SubscriptionPlans />} />
      <Route path="downloads" element={<Downloads />} />
      <Route path="employee/profile" element={<EmployeeProfile />} />
      <Route
        path="chat"
        element={
          <ProtectedRoute>
            <Navigate to="/company/chat" replace />
          </ProtectedRoute>
        }
      />

      <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />

      {/* Fallback for undefined routes, redirect to login */}
      <Route path="*" element={<Navigate to="/auth/sign-in" replace />} />
    </Routes>
  );
};

export default App;
